import { useRoutes } from 'react-router-dom';
import {
  AboutUs,
  BookAnAppointment,
  ContactUs,
  Impact,
  Landing,
  Search,
  Services,
} from 'features/misc';
import { publicRoutes } from './public';
import { useAuth } from 'lib/auth';
import { protectedRoutes } from './protected';

export const AppRoutes = () => {
  const auth = useAuth();

  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/contact-us', element: <ContactUs /> },
    { path: '/about-us', element: <AboutUs /> },
    { path: '/impact', element: <Impact /> },
    { path: '/services', element: <Services /> },
    { path: '/search', element: <Search /> },
    { path: '/book-appointment', element: <BookAnAppointment /> },
  ];

  const routes = auth.user ? protectedRoutes : publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
